export const DUMMY_IMAGE_PATH =
  "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7";
export const USER_REWARD_NAME = "勤続支援金";
export const PHONE_ENTRY_TEL_NUMBER = "0120-248-101";
export const ANYCAREER_TEL_NUMBER = "0120-415-032";

// アプリ関連
// アプリWebView閲覧時にbodyのdata属性(data-mobile-app)に以下が入る
export const IOS_APP_ID = 1;
export const ANDROID_APP_ID = 2;

// modelのattribute名は１箇所で管理した方がいいかも
export const MODEL_ATTRIBUTE_NAME = {
  workContent: {
    occupation: "役職・採用対象",
    occupationText: "役職・採用対象の詳細",
  },
};

// TODO: @root/constants/employments から EMPLOYMENT を import するように修正してください
export const EMPLOYMENT_TYPE = {
  FULL_TIME_ID: 1, // 正社員
  OTHER_ID: 2, // その他
  CONTRACT_ID: 3, // 契約社員
  FREELANCE_ID: 4, // 業務委託
  PART_TIME_ID: 5, // アルバイト・パート
} as const;

// TODO: @root/constants/jobTypeCategories から JOB_TYPE_CATEGORY を import するように修正してください
export const JOB_TYPE_CATEGORY = {
  BIYO_ID: 1, // 美容
  RELAXATION_ID: 2, // リラクゼーション
  CHIRYO_ID: 3, // 治療
  SPORTS_ID: 4, // スポーツ
  CARE_ID: 5, // 介護
  OTHER_ID: 6, // その他
  SHIKA_ID: 7, // 歯科
  RESTAURANT_ID: 8, // 飲食
  HOTEL_ID: 9, // ホテル
  MEDICAL_ID: 10, // 医科
} as const;

// 経験ID
export const JOB_TYPE_EXPERIENCE = {
  ESTHETICIAN_SCHOOL_GRADUATE_ID: 119, // エステティシャン スクール既卒・在学中
  NAILIST_SCHOOL_GRADUATE_ID: 121, // ネイリスト スクール既卒・在学中
  BIYOSHI_SCHOOL_GRADUATE_ID: 123, // 美容師 専門学校既卒・在学中
  EYELIST_SCHOOL_GRADUATE_ID: 127, // アイリスト 専門学校既卒・在学中
  THERAPIST_SCHOOL_GRADUATE_ID: 131, // セラピスト スクール既卒・在学中
} as const;

// リジョブエージェントの友だち追加用LINE URL
export const AGENT_LINE_URL =
  "https://aura-mico.jp/qr-codes/c52323d191c33178349e4557046e1313/preview";

// 会員登録時の年齢制限
// 対象とする最小年齢（◯歳以上）
export const REGISTERABLE_MIN_AGE = 15;
// 対象とする最大年齢（◯歳以下）
export const REGISTERABLE_MAX_AGE = 100;
